export const STATUS_BADGE = {
  scheduled: { variant: 'secondary', label: 'Scheduled' },
  in_progress: { variant: 'default', label: 'In Progress' },
  completed: { variant: 'secondary', label: 'Completed' },
  artifacts_ready: { variant: 'default', label: 'Artifacts Ready' },
  evaluated: { variant: 'default', label: 'AI Evaluated' },
  cancelled: { variant: 'outline', label: 'Cancelled' },
  failed: { variant: 'destructive', label: 'Failed' },
};

export const KIND_COPY = {
  tech: {
    title: 'Panel Interview',
    subtitle: 'Microsoft Teams sessions auto-recorded & auto-transcribed via Graph.',
    scheduleButton: 'Schedule Panel',
    scheduleTitle: 'Schedule Panel Interview',
    scheduleDescription:
      'Creates a Microsoft Teams meeting on hireiq@kadellabs.com and emails invites to the candidate and panelists. The meeting auto-records and auto-transcribes.',
    defaultSubject: 'Technical panel interview',
    defaultDescription: 'Discuss recent work + system design.',
    empty: 'No panel interviews scheduled yet.',
    loading: 'Loading panel interviews…',
    membersLabel: 'Panel members',
    successToast: 'Panel interview scheduled — invites sent via Outlook.',
    cancelToast: 'Panel interview cancelled.',
    testIdRoot: 'panels-tab',
    testIdSchedule: 'schedule-panel-button',
    testIdDialog: 'schedule-panel-dialog',
  },
  hr: {
    title: 'HR Call',
    subtitle: 'Schedule an HR Teams call with the candidate and HR panellists. Recording and transcript sync via Graph.',
    scheduleButton: 'Schedule HR Call',
    scheduleTitle: 'Schedule HR Call',
    scheduleDescription:
      'Creates a Microsoft Teams meeting and emails invites to the candidate and HR panellists. The meeting auto-records and auto-transcribes.',
    defaultSubject: 'HR panel call',
    defaultDescription: 'Culture fit and behavioural discussion.',
    empty: 'No HR calls scheduled yet.',
    loading: 'Loading HR calls…',
    membersLabel: 'HR panellists',
    successToast: 'HR call scheduled — invites sent via Outlook.',
    cancelToast: 'HR call cancelled.',
    testIdRoot: 'hr-panels-tab',
    testIdSchedule: 'schedule-hr-panel-button',
    testIdDialog: 'schedule-hr-panel-dialog',
  },
};

export const CANDIDATE_ON_PANEL_MSG = 'Panel member email must differ from the candidate email.';
